"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 81563:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* reexport */ Icon_Icon)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/Icon/Icon.tsx



const Icon = ({
  icon,
  alt = "Icon",
  className
}) => {
  // Priority: icon.svg -> icon.url -> broken image
  if (icon?.svg) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: className,
      dangerouslySetInnerHTML: {
        __html: icon.svg
      },
      "data-test-id": "Icon"
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
    src: icon?.url || "",
    alt: alt,
    className: className,
    "data-test-id": "Icon"
  });
};

/* harmony default export */ const Icon_Icon = (Icon);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/Icon/index.ts


/***/ }),

/***/ 25233:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PersuasionComponent_PersuasionComponent)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/mypartner/Icon/index.ts + 1 modules
var Icon = __webpack_require__(81563);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/PersuasionComponent/PersuasionComponent.style.ts

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PersuasionComponentstyle__Container",
  componentId: "ylf2am-0"
})(["display:flex;align-items:center;justify-content:center;background-color:#fbedd4;padding:8px 20px;border-radius:12px;gap:8px;position:relative;"]);
const IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PersuasionComponentstyle__IconContainer",
  componentId: "ylf2am-1"
})(["width:20px;height:20px;flex-shrink:0;display:flex;align-items:center;justify-content:center;img{width:100%;height:100%;object-fit:contain;}svg{width:100%;height:100%;}"]);
const TextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PersuasionComponentstyle__TextContainer",
  componentId: "ylf2am-2"
})(["display:flex;align-items:center;gap:4px;"]);
const InfoButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "PersuasionComponentstyle__InfoButton",
  componentId: "ylf2am-3"
})(["width:16px;height:16px;cursor:pointer;color:#757575;background:none;border:none;padding:0;margin:0;display:flex;align-items:center;justify-content:center;position:relative;svg{width:100%;height:100%;}&:focus{outline:2px solid #4a90e2;outline-offset:2px;border-radius:2px;}"]);
const TooltipContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PersuasionComponentstyle__TooltipContainer",
  componentId: "ylf2am-4"
})(["position:absolute;top:calc(100% + 8px);left:50%;transform:translateX(-50%);background-color:#000000;color:#ffffff;border-radius:4px;padding:8px;box-shadow:0px 1px 7px 0px rgba(0,0,0,0.2);z-index:1000;max-width:300px;white-space:nowrap;word-wrap:break-word;&::before{content:\"\";position:absolute;bottom:100%;left:50%;transform:translateX(-50%);width:0;height:0;border-left:9px solid transparent;border-right:9px solid transparent;border-bottom:9px solid #000000;}"]);
const TitleText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PersuasionComponentstyle__TitleText",
  componentId: "ylf2am-5"
})(["color:#000000;font-size:16px;font-weight:700;line-height:1.2;text-align:left;"]);
const TooltipText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PersuasionComponentstyle__TooltipText",
  componentId: "ylf2am-6"
})(["color:#ffffff;font-size:14px;font-weight:400;line-height:1.43;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/PersuasionComponent/PersuasionComponent.tsx



 // Optimized SVG icons



const DEFAULT_MONEY_ICON = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="8" fill="url(#paint0_linear)" stroke="#3B385E" stroke-width="0.33"/>
  <path d="M12.58 8.56c-.03-.03-.07-.04-.12-.04h-.88c-.05-.26-.16-.5-.33-.71h1.2c.04 0 .08-.02.11-.05.03-.03.05-.07.05-.11v-.5c0-.04-.02-.08-.05-.11-.03-.03-.07-.04-.11-.04H8.17c-.04 0-.08.02-.11.05-.03.03-.05.07-.05.11v.65c0 .04.02.08.05.11.03.03.07.04.11.04h.75c.72 0 1.18.18 1.38.55H8.17c-.04 0-.08.02-.11.05-.03.03-.05.07-.05.11v.5c0 .04.02.08.05.11.03.03.07.04.11.04h2.2c-.08.27-.25.47-.53.61-.28.14-.64.21-1.09.21h-.58c-.04 0-.08.02-.11.05-.03.03-.05.07-.05.11v.62c0 .04.02.08.05.11.66.67 1.51 1.6 2.56 2.8.03.04.07.06.13.06h1c.07 0 .12-.03.15-.09.03-.06.03-.11-.02-.16-1-.17-1.79-1.05-2.36-1.63.58-.07 1.05-.25 1.42-.54.36-.29.58-.67.66-1.14h.86c.04 0 .08-.02.11-.05.03-.03.05-.07.05-.11v-.5c0-.04-.02-.08-.05-.11z" fill="#3B385E"/>
  <defs>
    <linearGradient id="paint0_linear" x1="5.19" y1="-1.63" x2="-0.95" y2="17.58" gradientUnits="userSpaceOnUse">
      <stop stop-color="#F8E24E"/>
      <stop offset="1" stop-color="#EEC42F"/>
    </linearGradient>
  </defs>
</svg>`;
const INFO_ICON = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="6.4" stroke="#757575"/>
  <path d="M8.67 7.32v4.41c0 .37-.3.67-.67.67s-.67-.3-.67-.67V7.32c0-.37.3-.67.67-.67s.67.3.67.67z" fill="#757575"/>
  <circle cx="8" cy="5.17" r="0.87" fill="#757575"/>
</svg>`;

const PersuasionComponent = ({
  icon,
  title,
  popover
}) => {
  const {
    0: showTooltip,
    1: setShowTooltip
  } = (0,react.useState)(false);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    "data-test-id": "PersuasionComponent-Container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconContainer, {
      "data-test-id": "PersuasionComponent-IconContainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        icon: icon || {
          svg: DEFAULT_MONEY_ICON
        },
        alt: "Persuasion icon",
        "data-test-id": "PersuasionComponent-Icon"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextContainer, {
      "data-test-id": "PersuasionComponent-TextContainer",
      children: [title?.text?.value && /*#__PURE__*/(0,jsx_runtime.jsx)(TitleText, {
        "data-test-id": "PersuasionComponent-TitleText",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: title.text.value,
          "data-test-id": "PersuasionComponent-FormattedText"
        })
      }), popover?.description && /*#__PURE__*/(0,jsx_runtime.jsxs)(InfoButton, {
        type: "button",
        onClick: () => setShowTooltip(!showTooltip),
        onMouseEnter: () => setShowTooltip(true),
        onMouseLeave: () => setShowTooltip(false),
        "data-test-id": "PersuasionComponent-InfoButton",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          icon: {
            svg: INFO_ICON
          },
          alt: "Info icon",
          "data-test-id": "PersuasionComponent-Icon"
        }), showTooltip && /*#__PURE__*/(0,jsx_runtime.jsx)(TooltipContainer, {
          "data-test-id": "PersuasionComponent-TooltipContainer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TooltipText, {
            "data-test-id": "PersuasionComponent-TooltipText",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: popover.description,
              "data-test-id": "PersuasionComponent-FormattedText"
            })
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ const PersuasionComponent_PersuasionComponent = (PersuasionComponent);

/***/ }),

/***/ 14424:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PlanCardsList_PlanCardsList)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/mypartner/contexts/FilterContext.tsx
var FilterContext = __webpack_require__(22841);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/MoreBenefits/index.ts + 1 modules
var MoreBenefits = __webpack_require__(32265);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/DownloadPolicyModal.style.ts

const ModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DownloadPolicyModalstyle__ModalContent",
  componentId: "uw0e6l-0"
})(["display:flex;flex-direction:column;gap:16px;"]);
const PolicyDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DownloadPolicyModalstyle__PolicyDescription",
  componentId: "uw0e6l-1"
})(["font-weight:400;font-size:16px;line-height:1.2;color:#4a4a4a;"]);
const OptionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DownloadPolicyModalstyle__OptionsContainer",
  componentId: "uw0e6l-2"
})(["background:#f5f5f5;border-radius:16px;margin-bottom:8px;padding:16px;display:flex;flex-direction:column;gap:8px;"]);
const OptionItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DownloadPolicyModalstyle__OptionItem",
  componentId: "uw0e6l-3"
})(["display:flex;align-items:center;gap:16px;padding:16px 0;cursor:pointer;border-bottom:1px solid #d8d8d8;&:last-child{border-bottom:none;}"]);
const RadioButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DownloadPolicyModalstyle__RadioButton",
  componentId: "uw0e6l-4"
})(["width:24px;height:24px;border:2px solid ", ";border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;"], props => props.isSelected ? "#008CFF" : "#757575");
const RadioButtonDot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DownloadPolicyModalstyle__RadioButtonDot",
  componentId: "uw0e6l-5"
})(["width:12px;height:12px;background:#008cff;border-radius:50%;"]);
const OptionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DownloadPolicyModalstyle__OptionContent",
  componentId: "uw0e6l-6"
})(["display:flex;flex-direction:column;gap:4px;flex:1;"]);
const OptionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "DownloadPolicyModalstyle__OptionTitle",
  componentId: "uw0e6l-7"
})(["font-weight:700;font-size:16px;line-height:1.2;color:#000000;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/shared/PrimaryButton.tsx




const StyledButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "PrimaryButton__StyledButton",
  componentId: "men2xg-0"
})(["background:linear-gradient( 135deg,rgba(83,178,254,1) 0%,rgba(6,90,243,1) 100% );color:white;border:none;border-radius:8px;cursor:pointer;font-weight:900;line-height:1.2;text-align:center;text-transform:uppercase;font-size:", "px;height:2.75em;padding:0.75em 16px;min-width:120px;width:", ";&:disabled{background:#cccccc;cursor:not-allowed;}"], props => props.fontSize, props => props.block ? "100%" : "auto");

const PrimaryButton = ({
  children,
  text,
  onClick,
  fontSize = 16,
  block = false,
  disabled = false
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, {
    onClick: onClick,
    fontSize: fontSize,
    block: block,
    disabled: disabled,
    "data-test-id": "PrimaryButton-StyledButton",
    children: text ? /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
      value: text,
      "data-test-id": "PrimaryButton-FormattedText"
    }) : children
  });
};

/* harmony default export */ const shared_PrimaryButton = (PrimaryButton);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/DownloadPolicyModal.tsx









const DownloadPolicyModal = ({
  data,
  quoteId,
  isOpen,
  onClose,
  csrfToken
}) => {
  const {
    0: selectedOptionIndex,
    1: setSelectedOptionIndex
  } = (0,react.useState)(0);
  const analytics = (0,insurance/* getAnalytics */.I)(); // Set the selected option based on defaultSelected when data changes

  (0,react.useEffect)(() => {
    if (data?.content?.options) {
      // Find the last option with defaultSelected: true
      // In case multiple options have defaultSelected: true, we take the last one
      let defaultIndex = 0;
      data.content.options.forEach((option, index) => {
        if (option.defaultSelected) {
          defaultIndex = index;
        }
      });
      setSelectedOptionIndex(defaultIndex);
    }
  }, [data]); // Ensure portal element exists

  (0,react.useEffect)(() => {
    if (!document.getElementById("portal")) {
      const portalDiv = document.createElement("div");
      portalDiv.id = "portal";
      document.body.appendChild(portalDiv);
    }
  }, []);

  if (!isOpen || !data) {
    return null;
  }

  const handleOptionSelect = index => {
    setSelectedOptionIndex(index);
  };

  const handleDownload = async () => {
    const selectedOption = data?.content?.options?.[selectedOptionIndex];
    const itineraryId = new URLSearchParams(window.location.search).get("itineraryId") || "";

    if (selectedOption && quoteId) {
      const templateType = selectedOption.id || "with_price";
      analytics?.trackListingEvents({
        actionType: `policy_downloaded_${templateType === "with_price" ? "with_price" : "without_price"}`
      });
      await (0,utils/* downloadPdfPost */.Gz)(quoteId, templateType, csrfToken, itineraryId);
      onClose?.();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(components.CommonModalDweb, {
    customTitle: data.header?.title,
    handleClick: onClose,
    nonClipHeading: true,
    customWidth: "500px",
    "data-test-id": "DownloadPolicyModal-CommonModalDweb",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalContent, {
      "data-test-id": "DownloadPolicyModal-ModalContent",
      children: [data.content?.description && /*#__PURE__*/(0,jsx_runtime.jsx)(PolicyDescription, {
        "data-test-id": "DownloadPolicyModal-PolicyDescription",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: data.content.description,
          "data-test-id": "DownloadPolicyModal-FormattedText"
        })
      }), data.content?.options && /*#__PURE__*/(0,jsx_runtime.jsx)(OptionsContainer, {
        "data-test-id": "DownloadPolicyModal-OptionsContainer",
        children: data.content.options.map((option, index) => {
          const keyValue = option.id || `option-${index}`;
          const isSelected = selectedOptionIndex === index;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(OptionItem, {
            onClick: () => handleOptionSelect(index),
            isSelected: isSelected,
            "data-test-id": `DownloadPolicyModal-OptionItem-${keyValue}`,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RadioButton, {
              isSelected: isSelected,
              "data-test-id": "DownloadPolicyModal-RadioButton",
              children: isSelected && /*#__PURE__*/(0,jsx_runtime.jsx)(RadioButtonDot, {
                "data-test-id": "DownloadPolicyModal-RadioButtonDot"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(OptionContent, {
              "data-test-id": "DownloadPolicyModal-OptionContent",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(OptionTitle, {
                "data-test-id": "DownloadPolicyModal-OptionTitle",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
                  value: option.label,
                  "data-test-id": "DownloadPolicyModal-FormattedText"
                })
              })
            })]
          }, keyValue);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(shared_PrimaryButton, {
        text: data.footer?.buttons?.[0]?.label,
        onClick: handleDownload,
        fontSize: 16,
        block: true,
        "data-test-id": "DownloadPolicyModal-PrimaryButton"
      })]
    })
  });
};

/* harmony default export */ const mypartner_DownloadPolicyModal = (DownloadPolicyModal);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/mypartner/Icon/index.ts + 1 modules
var Icon = __webpack_require__(81563);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/InsuranceListItem.style.ts

const CardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__CardContainer",
  componentId: "sc-13phr0o-0"
})(["background:#fff;border-radius:12px;padding:12px 16px;width:100%;margin-bottom:8px;"]); // Top Section: Logo + Title (Left) | Price + CTA (Right)

const TopSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__TopSection",
  componentId: "sc-13phr0o-1"
})(["display:flex;justify-content:space-between;align-items:center;min-height:45px;margin-bottom:12px;"]);
const LeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__LeftSection",
  componentId: "sc-13phr0o-2"
})(["display:flex;align-items:center;gap:16px;flex:1;"]);
const RightSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__RightSection",
  componentId: "sc-13phr0o-3"
})(["display:flex;align-items:center;gap:16px;flex-shrink:0;"]);
const LogoSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__LogoSection",
  componentId: "sc-13phr0o-4"
})(["flex-shrink:0;img{width:100%;}"]);
const TitleSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__TitleSection",
  componentId: "sc-13phr0o-5"
})(["flex:1;display:flex;flex-direction:column;gap:4px;"]);
const PlanTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InsuranceListItemstyle__PlanTitle",
  componentId: "sc-13phr0o-6"
})(["font-size:16px;font-weight:600;color:#1a1a1a;"]);
const CompanyName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InsuranceListItemstyle__CompanyName",
  componentId: "sc-13phr0o-7"
})(["font-size:14px;color:#666;"]); // Bottom Section: Benefits (Left) | Actions (Right)

const BottomSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__BottomSection",
  componentId: "sc-13phr0o-8"
})(["display:flex;padding:12px;align-items:center;gap:48px;border-radius:8px;background:#f2f2f2;justify-content:space-between;"]);
const ActionsSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__ActionsSection",
  componentId: "sc-13phr0o-9"
})(["display:flex;align-items:center;gap:16px;flex-shrink:0;"]);
const DownloadSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__DownloadSection",
  componentId: "sc-13phr0o-10"
})(["cursor:pointer;padding:0 8px;border-radius:4px;transition:background-color 0.2s ease;&:hover{background-color:#f5f5f5;}"]);
const PriceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__PriceContainer",
  componentId: "sc-13phr0o-11"
})(["display:flex;align-items:baseline;gap:8px;justify-content:flex-end;"]);
const StrikethroughPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InsuranceListItemstyle__StrikethroughPrice",
  componentId: "sc-13phr0o-12"
})(["color:#000;font-size:14px;text-decoration:line-through;"]);
const CurrentPrice = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InsuranceListItemstyle__CurrentPrice",
  componentId: "sc-13phr0o-13"
})(["color:#000;font-size:16px;font-weight:900;"]);
const PerPersonText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InsuranceListItemstyle__PerPersonText",
  componentId: "sc-13phr0o-14"
})(["color:#4a4a4a;font-size:12px;margin-left:4px;"]);
const DiscountWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__DiscountWrapper",
  componentId: "sc-13phr0o-15"
})(["display:flex;width:186px;padding:4px 4px 4px 20px;flex-direction:column;align-items:flex-end;border-radius:12px;background:linear-gradient(289deg,#fff6e3 0.59%,#fff 99.84%);margin-top:0;margin-left:auto;"]);
const DiscountText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__DiscountText",
  componentId: "sc-13phr0o-16"
})(["color:#000;font-size:12px;font-weight:700;"]);
const BuyButtonSection = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "InsuranceListItemstyle__BuyButtonSection",
  componentId: "sc-13phr0o-17"
})(["background:linear-gradient(92deg,#53b2fe 0%,#065af3 100%);color:white;border:none;border-radius:8px;padding:12px 16px;cursor:pointer;font-weight:600;font-size:12px;min-width:120px;transition:all 0.2s ease;text-transform:uppercase;&:hover{background:linear-gradient(92deg,#4a9fe8 0%,#0548db 100%);transform:translateY(-1px);box-shadow:0 4px 8px rgba(83,178,254,0.3);}&:active{background:linear-gradient(92deg,#3b8dd4 0%,#0440c3 100%);transform:translateY(0);}"]);
const BenefitsSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__BenefitsSection",
  componentId: "sc-13phr0o-18"
})(["display:flex;justify-content:space-between;flex:1;height:16px;@media (max-width:768px){flex-direction:column;gap:16px;}"]);
const BenefitItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__BenefitItem",
  componentId: "sc-13phr0o-19"
})(["display:flex;align-items:center;gap:8px;min-width:0;@media (max-width:768px){flex:none;}"]);
const BenefitIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InsuranceListItemstyle__BenefitIcon",
  componentId: "sc-13phr0o-20"
})(["flex-shrink:0;width:24px;height:24px;display:flex;align-items:center;justify-content:center;img{width:20px;height:20px;object-fit:contain;}"]);
const BenefitText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__BenefitText",
  componentId: "sc-13phr0o-21"
})(["display:flex;align-items:center;flex:1;min-width:0;gap:8px;> span:first-child{color:#000;font-size:12px;line-height:16px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;}> span:last-child{color:#000;font-size:12px;font-weight:700;line-height:16px;flex-shrink:0;white-space:nowrap;}"]);
const MoreBenefitsSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListItemstyle__MoreBenefitsSection",
  componentId: "sc-13phr0o-22"
})(["display:flex;align-items:center;gap:6px;color:#008cff;cursor:pointer;font-size:12px;font-weight:700;text-align:right;transition:all 0.2s ease;&:hover{color:#0070cc;}"]);
const DownloadIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InsuranceListItemstyle__DownloadIcon",
  componentId: "sc-13phr0o-23"
})(["color:#757575;transition:color 0.2s ease;display:inline-flex;align-items:center;justify-content:center;width:16px;height:17px;svg{width:100%;height:100%;}", ":hover &{color:#3367d6;}"], DownloadSection);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/InsuranceListItem.tsx
/* provided dependency */ var process = __webpack_require__(34406);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









 // Download icon SVG



const DOWNLOAD_ICON = `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.111 11.357a.89.89 0 0 0-.889.888v2.134c0 .141-.056.276-.156.376s-.235.156-.376.156H2.31c-.141 0-.276-.056-.376-.156s-.156-.235-.156-.376v-2.134a.889.889 0 1 0-1.778 0v2.134c0 .612.244 1.2.677 1.633s1.021.677 1.633.677h11.378c.612 0 1.2-.244 1.633-.677s.677-1.021.677-1.633v-2.134a.89.89 0 0 0-.889-.888Z" fill="currentColor"/>
  <path d="M8 .69a.89.89 0 0 0-.889.889v8.057L4.302 7.296a.89.89 0 0 0-1.138 1.365l4.267 3.556c.044.032.092.06.142.083.032.022.066.041.101.058.103.043.213.065.324.065s.221-.022.324-.065c.034-.017.068-.036.101-.057.05-.023.098-.051.142-.083l4.267-3.556a.89.89 0 0 0-1.138-1.365L8.89 9.636V1.579A.89.89 0 0 0 8 .69Z" fill="currentColor"/>
</svg>`;

const InsuranceListItem = ({
  quoteId,
  productId,
  logoUrl,
  companyName,
  planTitle,
  originalPrice,
  discountedPrice,
  perPersonText,
  discountText,
  benefits,
  moreBenefitsText,
  buyButtonText,
  onMoreBenefits,
  onDownload,
  csrfToken,
  downloadBenefitsModal,
  bottomsheet,
  insAmount,
  paxPerDay,
  buyBtn,
  moreBenefitsTitle = "More Benefits",
  moreBenefitsData
}) => {
  const {
    0: isDownloadModalOpen,
    1: setIsDownloadModalOpen
  } = (0,react.useState)(false);
  const {
    0: isMoreBenefitsModalOpen,
    1: setIsMoreBenefitsModalOpen
  } = (0,react.useState)(false);
  const planTitleValue = (0,FormattedText/* getPlainText */.i)(planTitle);
  const analytics = (0,insurance/* getAnalytics */.I)();
  (0,react.useEffect)(() => {
    if (analytics && planTitleValue) {
      analytics?.trackListingEvents({
        actionType: `${planTitleValue}_seen`
      });

      if (discountText) {
        analytics?.trackListingEvents({
          actionType: `commission_persuasion_shown_${planTitleValue}`
        });
      }
    }
  }, []);

  const buyProduct = (quoteId, productId) => {
    const searchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(searchParams.entries());

    const params = _objectSpread(_objectSpread({}, queryParams), {}, {
      countries: searchParams.get("countries"),
      startDate: searchParams.get("startDate"),
      endDate: searchParams.get("endDate"),
      travellers: searchParams.get("travellers"),
      isUpcomingTrip: searchParams.has("isUpcomingTrip") ? searchParams.get("isUpcomingTrip") : false,
      productId: productId || "",
      quoteId: quoteId || ""
    });

    navigation/* navigationActions.navigateToTravellerDetails */.ej.navigateToTravellerDetails(params);
  };

  const handleDownloadClick = () => {
    analytics?.trackListingEvents({
      actionType: `download_benefits_clicked`
    });
    setIsDownloadModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsDownloadModalOpen(false);
  };

  const handleMoreBenefitsClick = () => {
    analytics?.trackListingEvents({
      actionType: `View_details_clicked_${planTitleValue}`
    });
    setIsMoreBenefitsModalOpen(true);
    onMoreBenefits?.();
  };

  const handleBuyButton = () => {
    analytics?.trackListingEvents({
      actionType: `buy_now_clicked_details_${planTitleValue}`
    });
    buyProduct(quoteId, productId);
  };

  const handleCloseMoreBenefitsModal = () => {
    setIsMoreBenefitsModalOpen(false);
  }; // Check if debug mode is enabled via Next.js environment variable


  const isDebugMode = typeof process !== "undefined" && process?.env?.["MYPARTNER_FILTER_DEBUG"] === "true";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CardContainer, {
    style: {
      position: "relative"
    },
    "data-test-id": "InsuranceListItem-CardContainer",
    children: [isDebugMode && quoteId && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        position: "absolute",
        top: "5px",
        right: "5px",
        backgroundColor: "#ff0000",
        color: "white",
        padding: "2px 6px",
        fontSize: "10px",
        borderRadius: "3px",
        zIndex: 10,
        fontFamily: "monospace"
      },
      children: quoteId
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TopSection, {
      "data-test-id": "InsuranceListItem-TopSection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LeftSection, {
        "data-test-id": "InsuranceListItem-LeftSection",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoSection, {
          "data-test-id": "InsuranceListItem-LogoSection",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: logoUrl,
            alt: "Insurance Company Logo",
            style: {
              height: "40px"
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TitleSection, {
          "data-test-id": "InsuranceListItem-TitleSection",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PlanTitle, {
            "data-test-id": "InsuranceListItem-PlanTitle",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: planTitle,
              "data-test-id": "InsuranceListItem-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyName, {
            "data-test-id": "InsuranceListItem-CompanyName",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: companyName,
              "data-test-id": "InsuranceListItem-FormattedText"
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RightSection, {
        "data-test-id": "InsuranceListItem-RightSection",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PriceContainer, {
            "data-test-id": "InsuranceListItem-PriceContainer",
            children: [originalPrice && /*#__PURE__*/(0,jsx_runtime.jsx)(StrikethroughPrice, {
              "data-test-id": "InsuranceListItem-StrikethroughPrice",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: originalPrice,
                "data-test-id": "InsuranceListItem-FormattedText"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CurrentPrice, {
              "data-test-id": "InsuranceListItem-CurrentPrice",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: discountedPrice,
                "data-test-id": "InsuranceListItem-FormattedText"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PerPersonText, {
              "data-test-id": "InsuranceListItem-PerPersonText",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: perPersonText,
                "data-test-id": "InsuranceListItem-FormattedText"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DiscountWrapper, {
            "data-test-id": "InsuranceListItem-DiscountWrapper",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DiscountText, {
              "data-test-id": "InsuranceListItem-DiscountText",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: discountText,
                "data-test-id": "InsuranceListItem-FormattedText"
              })
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(shared_PrimaryButton, {
          text: buyButtonText,
          onClick: () => {
            analytics?.trackListingEvents({
              actionType: `buy_now_clicked_outside_${planTitleValue}`
            });
            buyProduct(quoteId, productId);
          },
          fontSize: 12,
          "data-test-id": "InsuranceListItem-PrimaryButton"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BottomSection, {
      "data-test-id": "InsuranceListItem-BottomSection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitsSection, {
        "data-test-id": "InsuranceListItem-BenefitsSection",
        children: benefits?.map((benefit, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitItem, {
          "data-test-id": "InsuranceListItem-BenefitItem",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitIcon, {
            "data-test-id": "InsuranceListItem-BenefitIcon",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
              icon: benefit.icon,
              alt: "Benefit icon",
              "data-test-id": "InsuranceListItem-Icon"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitText, {
            "data-test-id": "InsuranceListItem-BenefitText",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: benefit.title,
              "data-test-id": "InsuranceListItem-FormattedText"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: benefit.amount,
              "data-test-id": "InsuranceListItem-FormattedText"
            })]
          })]
        }, `benefit-${benefit.icon.url || benefit.icon.svg || index}`))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ActionsSection, {
        "data-test-id": "InsuranceListItem-ActionsSection",
        children: [moreBenefitsData && /*#__PURE__*/(0,jsx_runtime.jsx)(MoreBenefitsSection, {
          onClick: handleMoreBenefitsClick,
          "data-test-id": "InsuranceListItem-MoreBenefitsSection",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: moreBenefitsText,
            "data-test-id": "InsuranceListItem-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DownloadSection, {
          onClick: handleDownloadClick,
          "data-test-id": "InsuranceListItem-DownloadSection",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DownloadIcon, {
            "data-test-id": "InsuranceListItem-DownloadIcon",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
              icon: {
                svg: DOWNLOAD_ICON
              },
              alt: "Download",
              "data-test-id": "InsuranceListItem-Icon"
            })
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(mypartner_DownloadPolicyModal, {
      data: downloadBenefitsModal,
      quoteId: quoteId,
      isOpen: isDownloadModalOpen,
      onClose: handleCloseModal,
      csrfToken: csrfToken,
      "data-test-id": "InsuranceListItem-DownloadPolicyModal"
    }), isMoreBenefitsModalOpen && moreBenefitsData && /*#__PURE__*/(0,jsx_runtime.jsx)(MoreBenefits/* default */.Z, {
      data: _objectSpread(_objectSpread({}, moreBenefitsData), {}, {
        csrfToken: csrfToken
      }),
      moreBenfitsTitle: moreBenefitsTitle,
      handleClose: handleCloseMoreBenefitsModal,
      handleBuyButton: handleBuyButton,
      "data-test-id": "InsuranceListItem-MoreBenefits"
    })]
  });
};

/* harmony default export */ const mypartner_InsuranceListItem = (InsuranceListItem);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/mypartner/PersuasionComponent/PersuasionComponent.tsx + 1 modules
var PersuasionComponent = __webpack_require__(25233);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/PlanCardsList/PlanCardsList.style.ts

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PlanCardsListstyle__Container",
  componentId: "oo2fwv-0"
})(["width:100%;display:flex;flex-direction:column;gap:12px;padding-bottom:48px;"]);
const EmptyState = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PlanCardsListstyle__EmptyState",
  componentId: "oo2fwv-1"
})(["text-align:center;padding:40px;color:#666;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/PlanCardsList/PlanCardsList.tsx


function PlanCardsList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PlanCardsList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PlanCardsList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PlanCardsList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





 // Local MyPartner object to avoid circular dependency


const MyPartner = {
  InsuranceListItem: mypartner_InsuranceListItem,
  PersuasionComponent: PersuasionComponent/* default */.Z
};

const PlanCardsList = ({
  data,
  csrfToken
}) => {
  const {
    quoteIds,
    setInitialQuoteIds
  } = (0,FilterContext/* useFilterContext */.j4)(); // Handle the data structure - memoized to prevent useEffect re-runs

  const allInsuranceCards = (0,react.useMemo)(() => {
    if (Array.isArray(data)) {
      return data;
    } else if (data && typeof data === "object" && "data" in data) {
      const dataObj = data;
      return Array.isArray(dataObj.data) ? dataObj.data : [];
    }

    return [];
  }, [data]); // Initialize context with all quote IDs from API data - preserve original order

  (0,react.useEffect)(() => {
    const originalQuoteIds = allInsuranceCards.map(card => card.quoteId).filter(Boolean);

    if (originalQuoteIds.length > 0) {
      setInitialQuoteIds(originalQuoteIds);
    }
  }, [allInsuranceCards, setInitialQuoteIds]); // Use context as single source of truth - filter cards based on quoteIds from context

  const insuranceCards = (0,react.useMemo)(() => {
    // Only show cards that match the quoteIds from context
    // If quoteIds is empty, show empty array (not all cards)
    const filtered = [];
    quoteIds.forEach(quoteId => {
      const matchingCard = allInsuranceCards.find(card => card.quoteId === quoteId);

      if (matchingCard) {
        filtered.push(matchingCard);
      }
    });
    return filtered;
  }, [quoteIds, allInsuranceCards]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
    "data-test-id": "PlanCardsList-Container",
    children: insuranceCards.length > 0 ? insuranceCards.map((cardProps, index) => {
      // Use quoteId as the key for proper React rendering
      const keyValue = cardProps.quoteId || `fallback-${index}`;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MyPartner.InsuranceListItem, PlanCardsList_objectSpread({
        csrfToken: csrfToken
      }, cardProps), keyValue);
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyState, {
      "data-test-id": "PlanCardsList-EmptyState",
      children: data ? "No insurance plans available" : "Loading insurance plans..."
    })
  });
};

/* harmony default export */ const PlanCardsList_PlanCardsList = (PlanCardsList);

/***/ }),

/***/ 22841:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hz": () => (/* binding */ FilterProvider),
/* harmony export */   "j4": () => (/* binding */ useFilterContext)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * URL and Session storage integration for filter persistence
 *
 * This context automatically saves and restores:
 * - Active filter selections (checkboxes, radio buttons, dropdowns)
 * - Current sort selection (price high/low, new launch)
 *
 * Data is stored in both URL query parameters and sessionStorage:
 * - URL parameters for sharing and bookmarking (e.g., sort=price_low_to_high&benefits=Medical,Adventure)
 * - Session storage as fallback for complex filter states
 *
 * Data is automatically restored when:
 * - User refreshes the page
 * - User navigates back to the page
 * - Component remounts
 * - User shares/bookmarks the URL
 *
 * Session storage is cleared when:
 * - Browser tab is closed
 * - clearStoredFilters() is called manually
 */
// Session storage keys


const SESSION_STORAGE_KEYS = {
  ACTIVE_FILTERS: "mypartner_active_filters",
  CURRENT_SORT: "mypartner_current_sort"
}; // Session storage utilities

const saveToSessionStorage = (key, value) => {
  try {
    if (true) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  } catch (error) {
    console.warn("Failed to save to session storage:", error);
  }
};

const loadFromSessionStorage = (key, defaultValue) => {
  try {
    if (true) {
      const item = sessionStorage.getItem(key);

      if (item) {
        return JSON.parse(item);
      }
    }
  } catch (error) {
    console.warn("Failed to load from session storage:", error);
  }

  return defaultValue;
};

const clearFiltersFromSessionStorage = () => {
  try {
    if (true) {
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.ACTIVE_FILTERS);
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.CURRENT_SORT);
    }
  } catch (error) {
    console.warn("Failed to clear session storage:", error);
  }
}; // URL parameter utilities


const updateURLParams = (filters, currentSort) => {
  if (false) {}

  try {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams; // Remove sort parameter first

    searchParams.delete("sort"); // Add current sort if exists

    if (currentSort) {
      searchParams.set("sort", currentSort);
    } // Group active filters by filter type


    const activeFilters = Object.entries(filters).filter(([_, enabled]) => enabled);
    const filterGroups = {};
    activeFilters.forEach(([filterId]) => {
      const [filterKey, criteriaTitle] = filterId.split("_");

      if (filterKey && criteriaTitle && filterKey !== "price") {
        // Skip price filter as it's handled by sort
        if (!filterGroups[filterKey]) {
          filterGroups[filterKey] = [];
        }

        filterGroups[filterKey].push(criteriaTitle);
      }
    }); // Get all current filter keys to remove unused ones

    const currentFilterKeys = Object.keys(filterGroups);
    const existingFilterKeys = [];
    searchParams.forEach((value, key) => {
      if (key !== "sort") {
        // Check if this might be a filter parameter by seeing if any active filter uses this key
        const isFilterParam = Object.entries(filters).some(([filterId]) => filterId.startsWith(`${key}_`));

        if (isFilterParam) {
          existingFilterKeys.push(key);
        }
      }
    }); // Remove filter parameters that are no longer active

    existingFilterKeys.forEach(filterKey => {
      if (!currentFilterKeys.includes(filterKey)) {
        searchParams.delete(filterKey);
      }
    }); // Add/update active filter groups to URL (comma-separated values)

    Object.entries(filterGroups).forEach(([filterKey, values]) => {
      searchParams.set(filterKey, values.join(","));
    }); // Update URL without page reload

    const newUrl = `${url.pathname}?${searchParams.toString()}`;
    window.history.replaceState(_objectSpread({}, window.history.state), "", newUrl);
  } catch (error) {
    console.warn("Failed to update URL parameters:", error);
  }
};

const loadFiltersFromURL = () => {
  if (false) {}

  try {
    const searchParams = new URLSearchParams(window.location.search);
    const activeFilters = {};
    let currentSort = null; // Load sort from URL

    const sortParam = searchParams.get("sort");

    if (sortParam) {
      currentSort = sortParam;
    } // Load other filters from URL


    searchParams.forEach((value, key) => {
      if (key !== "sort") {
        // Split comma-separated values and create filter IDs
        const values = value.split(",");
        values.forEach(criteriaTitle => {
          if (criteriaTitle.trim()) {
            const filterId = `${key}_${criteriaTitle.trim()}`;
            activeFilters[filterId] = true;
          }
        });
      }
    });
    return {
      activeFilters,
      currentSort
    };
  } catch (error) {
    console.warn("Failed to load filters from URL:", error);
    return {
      activeFilters: {},
      currentSort: null
    };
  }
}; // Generic sort type - now just a string key from API


const FilterContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
const useFilterContext = () => {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(FilterContext);

  if (!context) {
    throw new Error("useFilterContext must be used within a FilterProvider");
  }

  return context;
};
const FilterProvider = ({
  children
}) => {
  // Private state
  const {
    0: initialQuoteIds,
    1: setInitialQuoteIds
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
  const {
    0: filterData,
    1: setFilterData
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]); // Helper function to find sort criteria by key

  const findSortCriteria = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((sortFilter, sortKey) => {
    // Find criteria by matching the key directly
    return sortFilter.criteria.find(c => c.key === sortKey);
  }, []); // Public state

  const {
    0: quoteIds,
    1: setQuoteIds
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
  const {
    0: currentSort,
    1: setCurrentSort
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(() => {
    // First try to load from URL, then fallback to session storage
    const urlFilters = loadFiltersFromURL();
    return urlFilters.currentSort || loadFromSessionStorage(SESSION_STORAGE_KEYS.CURRENT_SORT, null);
  });
  const {
    0: activeFilters,
    1: setActiveFilters
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(() => {
    // First try to load from URL, then fallback to session storage
    const urlFilters = loadFiltersFromURL();
    const sessionFilters = loadFromSessionStorage(SESSION_STORAGE_KEYS.ACTIVE_FILTERS, {});
    return Object.keys(urlFilters.activeFilters).length > 0 ? urlFilters.activeFilters : sessionFilters;
  }); // Initialize quote IDs and preserve original order

  const setInitialQuoteIdsHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(quoteIds => {
    setInitialQuoteIds(quoteIds);
    setQuoteIds(quoteIds); // Initially show all
  }, []); // Save currentSort to both session storage and URL whenever it changes

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    saveToSessionStorage(SESSION_STORAGE_KEYS.CURRENT_SORT, currentSort);
    updateURLParams(activeFilters, currentSort);
  }, [currentSort, activeFilters]); // Save activeFilters to both session storage and URL whenever they change

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    saveToSessionStorage(SESSION_STORAGE_KEYS.ACTIVE_FILTERS, activeFilters);
    updateURLParams(activeFilters, currentSort);
  }, [activeFilters, currentSort]); // Initialize filter data

  const setInitialFilterData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(filterList => {
    const processedFilters = filterList.map(filter => _objectSpread(_objectSpread({}, filter), {}, {
      enabled: filter.enabled ?? false,
      filterId: filter.filterId || filter.key // Use filterId or fallback to key

    }));
    setFilterData(processedFilters); // Check for defaultSelected in price filter and set currentSort if not already set
    // Priority order: 1) URL params, 2) Session storage, 3) defaultSelected from price filter

    const priceFilter = processedFilters.find(filter => filter.key === "price");

    if (priceFilter && !currentSort) {
      const defaultSortCriteria = priceFilter.criteria.find(criteria => criteria.defaultSelected);

      if (defaultSortCriteria && defaultSortCriteria.key) {
        setCurrentSort(defaultSortCriteria.key);
      }
    } // Initialize active filters state


    const defaultActiveFilters = {};
    processedFilters.forEach(filter => {
      filter.criteria.forEach(criteria => {
        const criteriaId = `${filter.filterId}_${criteria.title.text.value}`; // Use defaultSelected property to determine initial selection

        defaultActiveFilters[criteriaId] = criteria.defaultSelected || false;
      });
    }); // Merge with session storage data, but only if session storage has valid filters

    const savedFilters = loadFromSessionStorage(SESSION_STORAGE_KEYS.ACTIVE_FILTERS, {}); // Check if saved filters are relevant to current filter structure

    const savedFilterKeys = Object.keys(savedFilters);
    const currentFilterKeys = Object.keys(defaultActiveFilters);
    const hasRelevantSavedFilters = savedFilterKeys.some(key => currentFilterKeys.includes(key)); // Use saved filters if they're relevant, otherwise use defaults

    if (hasRelevantSavedFilters) {
      const mergedFilters = _objectSpread(_objectSpread({}, defaultActiveFilters), savedFilters); // Only keep filters that are valid for current filter structure


      const validMergedFilters = Object.fromEntries(Object.entries(mergedFilters).filter(([key]) => currentFilterKeys.includes(key)));
      setActiveFilters(validMergedFilters);
    } else {
      setActiveFilters(defaultActiveFilters);
    }
  }, [currentSort]); // Calculate filtered and sorted quote IDs

  const calculateFilteredQuoteIds = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {
    let result = [...initialQuoteIds]; // Apply active filters

    const enabledFilters = Object.entries(activeFilters).filter(([_, enabled]) => enabled).map(([filterId]) => filterId);

    if (enabledFilters.length > 0) {
      // Group filters by filter type
      const filterGroups = {};
      enabledFilters.forEach(filterId => {
        const [filterKey] = filterId.split("_");

        if (!filterGroups[filterKey]) {
          filterGroups[filterKey] = [];
        }

        filterGroups[filterKey].push(filterId);
      }); // Apply each filter group (excluding price filter which is only for sorting)

      Object.entries(filterGroups).forEach(([filterKey, filterIds]) => {
        // Skip price filter - it's only used for sorting, never for filtering
        if (filterKey === "price") return;
        const filter = filterData.find(f => f.filterId === filterKey || f.key === filterKey);
        if (!filter) return;

        if (filterKey === "benefits") {
          // For benefits: INTERSECTION (AND logic) - plans must have ALL selected benefits
          filterIds.forEach(filterId => {
            const criteriaTitle = filterId.replace(`${filterKey}_`, "");
            const criteria = filter.criteria.find(c => c.title.text.value === criteriaTitle);

            if (criteria) {
              // Intersect current result with this benefit's quote IDs
              result = result.filter(id => criteria.quoteIds.includes(id));
            }
          });
        } else {
          // For other filters: UNION (OR logic) - plans can have ANY of the selected options
          const allowedQuoteIds = new Set();
          filterIds.forEach(filterId => {
            const criteriaTitle = filterId.replace(`${filterKey}_`, "");
            const criteria = filter.criteria.find(c => c.title.text.value === criteriaTitle);

            if (criteria) {
              criteria.quoteIds.forEach(id => allowedQuoteIds.add(id));
            }
          }); // Intersect with current result

          result = result.filter(id => allowedQuoteIds.has(id));
        }
      });
    } // Dedupe


    result = [...new Set(result)]; // Apply sorting

    if (currentSort && filterData.length > 0) {
      const sortFilter = filterData.find(f => f.key === "price");

      if (sortFilter) {
        const sortCriteria = findSortCriteria(sortFilter, currentSort);

        if (sortCriteria) {
          // Apply sort order while maintaining filtered results
          const sortedResult = [];
          sortCriteria.quoteIds.forEach(id => {
            if (result.includes(id)) {
              sortedResult.push(id);
            }
          });
          result = sortedResult;
        }
      }
    } else {
      // No sorting applied, maintain original order
      const originalOrderResult = [];
      initialQuoteIds.forEach(id => {
        if (result.includes(id)) {
          originalOrderResult.push(id);
        }
      });
      result = originalOrderResult;
    }

    return result;
  }, [initialQuoteIds, filterData, activeFilters, currentSort, findSortCriteria]); // Set sorting

  const setSort = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(sortKey => {
    setCurrentSort(sortKey);
    const filtered = calculateFilteredQuoteIds();
    setQuoteIds(filtered);
  }, [calculateFilteredQuoteIds]); // Clear stored filters from both session storage and URL

  const clearStoredFilters = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {
    clearFiltersFromSessionStorage(); // Clear only filter-related URL parameters

    if (true) {
      const url = new URL(window.location.href);
      const searchParams = url.searchParams; // Remove sort parameter

      searchParams.delete("sort"); // Get all current filter keys from activeFilters and remove them

      const filterKeysToRemove = [];
      searchParams.forEach((value, key) => {
        if (key !== "sort") {
          // Check if this might be a filter parameter by seeing if any active filter uses this key
          const isFilterParam = Object.entries(activeFilters).some(([filterId]) => filterId.startsWith(`${key}_`));

          if (isFilterParam) {
            filterKeysToRemove.push(key);
          }
        }
      }); // Remove all identified filter parameters

      filterKeysToRemove.forEach(param => searchParams.delete(param)); // Update URL

      const newUrl = `${url.pathname}?${searchParams.toString()}`;
      window.history.replaceState(_objectSpread({}, window.history.state), "", newUrl);
    }
  }, [activeFilters]); // Set individual filter

  const setFilter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((filterId, enabled) => {
    setActiveFilters(prev => {
      const updated = _objectSpread(_objectSpread({}, prev), {}, {
        [filterId]: enabled
      }); // Calculate immediately with the updated state


      const result = [...initialQuoteIds]; // Apply active filters using the updated state

      const enabledFilters = Object.entries(updated).filter(([_, isEnabled]) => isEnabled).map(([id]) => id);

      if (enabledFilters.length > 0) {
        // Group filters by filter type
        const filterGroups = {};
        enabledFilters.forEach(filterId => {
          const [filterKey] = filterId.split("_");

          if (!filterGroups[filterKey]) {
            filterGroups[filterKey] = [];
          }

          filterGroups[filterKey].push(filterId);
        }); // Apply each filter group (excluding price filter which is only for sorting)

        let filteredResult = result;
        Object.entries(filterGroups).forEach(([filterKey, filterIds]) => {
          // Skip price filter - it's only used for sorting, never for filtering
          if (filterKey === "price") return;
          const filter = filterData.find(f => f.filterId === filterKey || f.key === filterKey);
          if (!filter) return;

          if (filterKey === "benefits") {
            // For benefits: INTERSECTION (AND logic) - plans must have ALL selected benefits
            filterIds.forEach(filterId => {
              const criteriaTitle = filterId.replace(`${filterKey}_`, "");
              const criteria = filter.criteria.find(c => c.title.text.value === criteriaTitle);

              if (criteria) {
                // Intersect current result with this benefit's quote IDs
                filteredResult = filteredResult.filter(id => criteria.quoteIds.includes(id));
              }
            });
          } else {
            // For other filters: UNION (OR logic) - plans can have ANY of the selected options
            const allowedQuoteIds = new Set();
            filterIds.forEach(filterId => {
              const criteriaTitle = filterId.replace(`${filterKey}_`, "");
              const criteria = filter.criteria.find(c => c.title.text.value === criteriaTitle);

              if (criteria) {
                criteria.quoteIds.forEach(id => allowedQuoteIds.add(id));
              }
            }); // Intersect with current result

            filteredResult = filteredResult.filter(id => allowedQuoteIds.has(id));
          }
        }); // Apply sorting or maintain original order

        let finalResult = [...new Set(filteredResult)]; // Dedupe

        if (currentSort && filterData.length > 0) {
          const sortFilter = filterData.find(f => f.key === "price");

          if (sortFilter) {
            const sortCriteria = findSortCriteria(sortFilter, currentSort);

            if (sortCriteria) {
              const sortedResult = [];
              sortCriteria.quoteIds.forEach(id => {
                if (finalResult.includes(id)) {
                  sortedResult.push(id);
                }
              });
              finalResult = sortedResult;
            }
          }
        } else {
          // No sorting applied, maintain original order
          const originalOrderResult = [];
          initialQuoteIds.forEach(id => {
            if (finalResult.includes(id)) {
              originalOrderResult.push(id);
            }
          });
          finalResult = originalOrderResult;
        }

        setQuoteIds(finalResult);
      } else {
        // No filters active, show all in original order
        setQuoteIds([...initialQuoteIds]);
      }

      return updated;
    });
  }, [initialQuoteIds, filterData, currentSort, findSortCriteria]); // Recalculate when dependencies change

  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => {
    if (initialQuoteIds.length > 0 && filterData.length > 0) {
      const filtered = calculateFilteredQuoteIds();
      setQuoteIds(filtered);
    }
  }, [calculateFilteredQuoteIds, initialQuoteIds.length, filterData.length]);
  const value = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => ({
    quoteIds,
    setInitialQuoteIds: setInitialQuoteIdsHandler,
    setInitialFilterData,
    currentSort,
    setSort,
    activeFilters,
    setFilter,
    clearStoredFilters
  }), [quoteIds, setInitialQuoteIdsHandler, setInitialFilterData, currentSort, setSort, activeFilters, setFilter, clearStoredFilters]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(FilterContext.Provider, {
    value: value,
    children: children
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (FilterContext)));

/***/ })

}]);